import './AppUserCellEditor.scss';

import { AppUserSelect } from '../app-form';
import { BaseSelectRef } from 'rc-select';
import { EditBox } from '@ui/EditBox';
import { getClosestTableBody } from '@lib/popups';

import React, { useCallback, useRef, useState } from 'react';
import { useAsyncProcessing, useCurrentUser, useUpdateDataSecurityApp } from '@hooks';

export interface AppUserCellEditorProps {
	applicationId: number;
	user?: string;
}

export const AppUserCellEditor: React.FC<AppUserCellEditorProps> = ({ applicationId, user }) => {
	const inputRef = useRef<BaseSelectRef>(null);
	const { isReadOnly } = useCurrentUser();
	const [ newUser, setNewUser ] = useState(user);

	const { request, reset } = useUpdateDataSecurityApp();

	const process = useAsyncProcessing({
		resetAction: reset,
		stateSelector: useUpdateDataSecurityApp.selectors.state
	});

	const save = useCallback((value: string) => {
		process.watchNextCall();

		request({
			applicationId,
			rawSalesforceId: value ?? null
		});
	}, [ applicationId, process, request ]);

	const handleOnChange = useCallback((value: string) => {
		if (newUser !== value) {
			setNewUser(value ?? '');

			save(value);
		}
	}, [ newUser, save ]);

	return (
		<EditBox
			className='app-user-cell-editor'
			isReadOnly={ isReadOnly }
			isSpreadsheet
			selectionRef={ inputRef }
			state={ process.state }>
			<AppUserSelect
				allowClear
				disableUsed
				getPopupContainer={ getClosestTableBody }
				key={ user }
				onChange={ handleOnChange }
				popupMatchSelectWidth={ false }
				ref={ inputRef }
				value={ newUser } />
		</EditBox>
	);
};
